import "../pages/CheckIn.css";
import { React, useState,useEffect,useRef } from "react";
import DatePicker, { DateObject } from 'react-multi-date-picker';
import Box from '@mui/material/Box';
import { apiMain } from "../../App";
import { Messages } from "../data/Messages";
import { useSnackbar } from "notistack";
import { useParams } from 'react-router-dom';
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Loading } from "../Loading";
import Cost_Detail from "./Const_Detail";
import Cost_List from "./Cost_List";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FiberNewIcon from "@mui/icons-material/FiberNew";
function Cost(props){
   const [value, setValue] = useState('1');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [loading, setLoading] = useState(false);
  const [User, setUser] = useState([]);
  const [UserId,setUserId]=useState([]);
  const [Repidflag,setRepidflag]=useState(true);
  const [Addflag,setAddflag]=useState(true);
  const [AddOrEditFlag,setAddOrEditFlag]=useState(false);
  const [EditFlag,setEditFlag]=useState(false);
  const [DelFlag,setDelFlag]=useState(false);
  const [NewFlag,setNewFlag]=useState(true);
  const [Cust_id, setCust_id] = useState(0);
  const [Cust_mab, setCust_mab] = useState(0);
  const [Cust_d_mab, setCust_d_mab] = useState(0);
  const [Cust_d_date, setCust_d_date] = useState("");
  const [Cust_d_desc, setCust_d_desc] = useState("");
  const [Cust_date, setCust_date] = useState("");
  const [Cust_tasvie_date, setCust_tasvie_date] = useState("");
  const [Cust_ok,setCust_ok]=useState(0);
  const InputRef = useRef(null)
  const [U_id, setU_id] = useState(0);
  const [updateCount, setUpdateCount] = useState(0);
   useEffect(() => {
  //        if (props.permission.length>0)
  //        {

  setAddflag(props.permission[11].Per_Add)
  setEditFlag(props.permission[11].Per_Edit)
  setDelFlag(props.permission[11].Per_Del)
  //        }
  setAddOrEditFlag(0)
 setLoading(false)
 getMaxCust();
 getDataList();
    //   getData();
    //   getShowData();
   
 }, [])
//  useEffect(() => {
         
//   getData();
// }, [updateCount])
 
const getShowData = async () => {
  let uparams = new URLSearchParams();
  uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));

  let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectreservid?${uparams}`, true);

  // let res = await GetDataPromise(`${apiMain}/api/v1/reservation`, force);
  let parsed = JSON.parse(res);

  if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
    let newData = parsed.data;
  //   setDataView(newData)
  //  setPass_No(newData[0].Pass_No)
  //    setPass_FName(newData[0].Pass_FName)
  //    setPass_LName(newData[0].Pass_LName)
  }
 // setLoading(false)

}
const changeU_id = (event) => {
  setU_id(event.target.value);
};

  const getData = async ( id) => {

    let uparams = new URLSearchParams();
    uparams.append("cust_id",  id);

      let res = await GetDataPromise(`${apiMain}/api/v1/cust/selectcustid?${uparams}`, true);
 let temp = 0;
    let parsed = JSON.parse(res);
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
        setData(newData)
       
        // if (data!=null){
          newData.map((nd) => {
          temp = temp + nd['cust_d_mab']
          
        })}
          setCust_mab(temp)
    // }
  
}
const getViewcustid = async (id ) => {

  let uparams = new URLSearchParams();
  uparams.append("cust_id",  id);
    let res = await GetDataPromise(`${apiMain}/api/v1/cust/viewcustid?${uparams}`, true);

  let parsed = JSON.parse(res);
  if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
      let newData = parsed.data;
      //setData(newData)
      setCust_id(id)
     setCust_id(newData[0].cust_id)
     setCust_date(newData[0].cust_date)
     setCust_ok(newData[0].cust_ok)
     setCust_tasvie_date(newData[0].cust_tasvie_date)
     getData(id);

  }

}
const getDataList = async ( ) => {

  // let uparams = new URLSearchParams();
  // uparams.append("cust_id",  Cust_id);

    let res = await GetDataPromise(`${apiMain}/api/v1/cust`, true);

  let parsed = JSON.parse(res);
  if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
      let newData = parsed.data;
      console.log(newData)
      setDatalist(newData)
     
  }

}
const getMaxCust = async ( ) => {

  let uparams = new URLSearchParams();
  //uparams.append("U_id", localStorage.getItem('U_id'));

    let res = await GetDataPromise(`${apiMain}/api/v1/cust/maxcust`, true);

  let parsed = JSON.parse(res);
  if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
      let newData = parsed.data;
       setCust_id(newData)
     
  }

}
  const params = useParams()
   const [data, setData] = useState();
   const [datalist, setDatalist] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogError, setDialogError] = useState({});
  //const [Reserv_Id, setReserv_Id] = useState(0);
 	const [Id, setId] = useState(0);

   // const [Rtype_Id, setRtype_Id  ]=useState(0);
   
    const [PresentTypeData, setPresentTypeData] = useState([]);


  //   function handleCloseresturant() {
  //    // props.ChangeXpage(0)
  //  }

const changeCust_Date =(event)  =>{
  setCust_date(event.year + '-' + event.month + '-' + event.day);
 // console.log(event.year + '-' + event.month + '-' + event.day)
  }
  const changeCust_tasvie_date =(event)  =>{
    setCust_tasvie_date(event.year + '-' + event.month + '-' + event.day);
   // console.log(event.year + '-' + event.month + '-' + event.day)
    }
  const changeCust_d_Date =(event)  =>{
    setCust_d_date(event.year + '-' + event.month + '-' + event.day);
 //   console.log(event.year + '-' + event.month + '-' + event.day)
    }

    const sendDelete = async (e) => {
      let formdata = new FormData();
   
    // let errors = {};
      formdata.append("id", Id);

      let response;
      if(Id > 0){

           response = await PostDataPromise(apiMain + "/api/v1/cust_detail/delete", formdata);
         //  let parsed = JSON.parse(response);

           
       } 
         
      setDialogLoading(false);
      let parsed = JSON.parse(response);
      if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
          // okay
          enqueueSnackbar(Messages.success, { variant: 'success' });

          // props.save()
      } else {
          if(parsed.data && typeof parsed.data.message === "string"){
              enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
          }
          setDialogError((parsed.data) ? parsed.data.message : {})
      }
   //   setUpdateCount((prev) => prev + 1)
      getData(Cust_id);
      cleardata()
      AddOrEditCust();
    }
const cleardata=()=>{
  setId(0)
  setCust_d_date('');
  setCust_d_desc('');
  setCust_d_mab(0);

  setEditFlag(false);
  setDelFlag(false);
  
  setAddflag(true);
 // sumdata();
}
const clearalldata=()=>{
    getMaxCust();
  setId(0)
  setAddOrEditFlag(0)
  setCust_date('');
  setCust_mab(0);
  setCust_ok(0);
  setCust_d_date('');
  setCust_d_desc('');
  setCust_d_mab(0);

  setEditFlag(false);
  setDelFlag(false);
  setAddflag(true);
  getData(0);
}
const sumdata=()=>{
  let temp = 0;
  if (data!=null){
  data.map((nd) => {
    temp = temp + nd['cust_d_mab']
    
  })}
  console.log(temp)
 setCust_mab(temp)

}
    const sendUpdate = async (e) => {
      let formdata = new FormData();
   
  //    let errors = {};
     // setPass_Id(0);
     formdata.append("id", Id);
           formdata.append("cust_d_date", Cust_d_date);
              formdata.append("cust_d_desc", Cust_d_desc);  
            formdata.append("cust_d_mab", Cust_d_mab);
      let response;
      if(Id > 0){

           response = await PostDataPromise(apiMain + "/api/v1/cust_detail/update", formdata);

        //   let parsed = JSON.parse(response);

           
       }
      setDialogLoading(false);
      let parsed = JSON.parse(response);
      console.log(response)
      if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
          // okay
          enqueueSnackbar(Messages.success, { variant: 'success' });

          // props.save()
      } else {
          if(parsed.data && typeof parsed.data.message === "string"){
              enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
          }
          setDialogError((parsed.data) ? parsed.data.message : {})
      }
      // setUpdateCount((prev) => prev + 1)
      getData(Cust_id);
      cleardata();
      AddOrEditCust();
  }
  const AddOrEditCust = async (e) => {
    let response;
if (!AddOrEditFlag)
{
 
   let formdatacust = new FormData();
   formdatacust.append("cust_id", Cust_id);
   formdatacust.append("cust_date", Cust_date);
   formdatacust.append("cust_mab", Cust_mab);  
   formdatacust.append("cust_tasvie_date", Cust_tasvie_date);
   // formdatacust.append("U_Refer_Id", U_id);
   formdatacust.append("cust_ok", Cust_ok);
        formdatacust.append("U_id",  localStorage.getItem('U_id'));  
        response = await PostDataPromise(apiMain + "/api/v1/cust/insert", formdatacust); 
        setAddOrEditFlag(true)
}
//else
// {
//  let formdatacust = new FormData();
//  console.log(Cust_id)
//  formdatacust.append("cust_id", Cust_id);
//  formdatacust.append("cust_date", Cust_date);
//  formdatacust.append("cust_mab", Cust_mab);  
//  formdatacust.append("cust_tasvie_date", Cust_tasvie_date);
//  // formdatacust.append("U_Refer_Id", U_id);
//  formdatacust.append("cust_ok", Cust_ok);
//      // formdatacust.append("U_id",  localStorage.getItem('U_id'));  
//       response = await PostDataPromise(apiMain + "/api/v1/cust/update", formdatacust); 
//       setRepidflag(true)
//       console.log(response)
// }
  }
  const sendAdd = async (e) => {
         let response;
         AddOrEditCust();
        
   let formdata = new FormData();
   formdata.append("cust_id", Cust_id);
         formdata.append("cust_d_date", Cust_d_date);
            formdata.append("cust_d_desc", Cust_d_desc);  
          formdata.append("cust_d_mab", Cust_d_mab);
 
    if(Id == 0){
        // new
         response = await PostDataPromise(apiMain + "/api/v1/cust_detail/insert", formdata);

        }
    setDialogLoading(false);
    let parsed = JSON.parse(response);
    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        // okay
        enqueueSnackbar(Messages.success, { variant: 'success' });

        // props.save()
    } else {
        if(parsed.data && typeof parsed.data.message === "string"){
            enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
        }
        setDialogError((parsed.data) ? parsed.data.message : {})
    }
     getData(Cust_id);
    cleardata();
}
  //  const [count, setCount] = useState(0); // useState returns a pair. 'count' is the current state. 'setCount' is a function we can use to update the state.
  function allitemupdate(id,Cust_d_date,Cust_d_desc,Cust_d_mab)
  {

   setId(id);
   setCust_d_date(Cust_d_date);
   setCust_d_desc(Cust_d_desc);
   setCust_d_mab(Cust_d_mab);
   setEditFlag(true);
   setDelFlag(true);
   setAddflag(false);
    InputRef.current.focus()
   

  }
  function listview(id)
  {
   setCust_id(id);
 getViewcustid(id);
 setAddOrEditFlag(1)
   //sumdata();

  }
// if (loading)
// {return
//   <Loading small={true}/>}

 
    return (
        <>
    {/* <div style={{  display:'flex',  gap: '10px',  height:'100vh'}}>
      <div style={{ display: 'flex' , flexDirection: 'column' , gap: '10px' , flex: 1}}>
        <div style={{ padding: '20px' , borderRadius: '8px' , background:'lightblue'}}>Div 1</div>
        <div style={{ padding: '20px' , borderRadius: '8px' ,  background:'lightgreen'}}>Div 2</div>
      </div>
      <div style={{ padding: '20px' , borderRadius: '8px' ,  background:'lightcoral',flex:1}}>Div 3</div>
    </div> */}
  <div style={{  display:'flex',  gap: '10px',  height:'100vh'}}>
      <div style={{ display: 'flex' , flexDirection: 'column' , gap: '10px' , flex: 1}}>
            <div className="CheckIn" style={{display:'flex',float:'left',textAlign:'left',height:'35px', width:'500px',marginTop:'0px',marginLeft:'0px'}}>

               <fieldset>
                <form action="#" method="get">
                <div style={{marginTop:'0px'}}>
                <label style={{fontsize:'10px'}} for="checkoutdate">Cust Number</label>
                <input
                        type="text"
                        id="Prese_Id"
                        disabled={true}
                        value={Cust_id}
                        onChange={(e) =>
                            setCust_id(e.target.value)
                        }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'60px',marginLeft:'5px'}}
                    />
                   <label  for="checkoutdate" style={{marginLeft:'10px',fontsize:'12px'}}>Cust date*</label>
                     <DatePicker
                  style={{height:"35px", marginLeft:"20px",width:'80px'}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                        disabled={false}
                         calendarPosition="bottom"
                         selected={Date.now()}
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={Cust_date} 
                  
                   onChange={changeCust_Date}
                        // range={range}
                        // rangeHover={range}
                    />
       <Chip label="New" onClick={clearalldata} color="primary" disabled={!NewFlag} sx={{width:80 ,cursor:'pointer',marginLeft:'10px'}} />

         </div>
         </form>
          </fieldset>
          </div>
             <div className="CheckIn" style={{float:'left',textAlign:'left', width:'500px',marginTop:'0px',marginLeft:'0px'}}>
               <fieldset>
                <form action="#" method="get">
                <div style={{marginTop:'2px'}}>
 
                   <label style={{fontsize:'12px'}}  for="checkoutdate"> date*</label>
                     <DatePicker
                  style={{height:"35px", marginLeft:"50px"}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                        disabled={false}
                         calendarPosition="bottom"
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={Cust_d_date} 
                  
                   onChange={changeCust_d_Date}
                        // range={range}
                        // rangeHover={range}
                    />
                        {/* <div style={{marginLeft:'10px'}}>  */}
                       <label  for="  Amount" style={{marginLeft:'20px',fontsize:'12px'}}>Amount*</label>
                       {/* </div> */}
                       <input
                        type="text"
                        id="Prese_Id"
                        disabled={false}
                        value={Cust_d_mab}
                        ref={InputRef}
                        onChange={(e) =>
                            setCust_d_mab(e.target.value)
                        }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'160px'}}
                    />


               <div style={{marginTop:'0px'}}>
               <label  for="  Description" style={{marginLeft:'0px',fontsize:'12px'}}>Description*</label>
                 <input
                        type="text"
                        id="Prese_Id"
                        disabled={false}
                        value={Cust_d_desc}
                        ref={InputRef}
                        onChange={(e) =>
                            setCust_d_desc(e.target.value)
                        }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'400px'}}
                    />
             </div>
            
       <Stack direction="row" spacing={1} style={{paddingLeft:'30px',marginTop:'0px'}}>
       <Chip icon={<FiberNewIcon />} label="New" onClick={cleardata} color="primary" disabled={!NewFlag} sx={{width:80 ,cursor:'pointer'}} />

        <Chip icon={<AddIcon />} label="Add" onClick={sendAdd} color="primary" disabled={!Addflag} sx={{width:80 ,cursor:'pointer'}} />
        <Chip icon={<EditIcon />} label="Edit" onClick={sendUpdate} color="primary" disabled={!EditFlag} sx={{width:80 ,cursor:'pointer'}} />

        <Chip icon={<DeleteIcon />} label="Delete" onClick={sendDelete} color="error" disabled={!DelFlag} sx={{width:80 , cursor:'pointer'}} />
     
     
     
      </Stack>
          </div>
                    </form>
            </fieldset>
</div>
 {/* <Box sx={{ display:'inline-block', width:'600px',height:'450px', marginLeft:'470px',marginTop:'-180px'}}> */}
      {/* <div className="CheckIn" style={{display:'inline-block', width:'300px',height:'570px', marginLeft:'650px',marginTop:'0px'}}>  
      <img onClick={() => handleCloseresturant()} src={ico2} alt={"/"} style={{ float:'right',width: '30px', height: '30px', cursor: 'pointer' }} />

               <img  src={rest1} alt={"/" } style={{paddingTop:'100px'}} /> 
 </div>   */}
   {/* </Box> */}
  
  <div className="CheckIn" style={{float:'left', width:'500px',height:'250px',marginTop:'0px',marginLeft:'0px'}}> 
 
     <Cost_Detail allupdate={allitemupdate} Room_Number={params.id} data={data}  />
 
  </div>
  
  <div className="CheckIn" style={{float:'left',textAlign:'left',height:'65px', width:'500px',marginTop:'0px',marginLeft:'0px'}}>
               <fieldset>
                <form action="#" method="get">
                <div style={{marginTop:'0px'}}>
             
                   <label  for="checkoutdate" style={{marginLeft:'0px'}}>Settlement date </label>
                     <DatePicker
                  style={{height:"35px", marginLeft:"10px",width:'90px'}}
                        // inputClass={"rmdp-input "+ classes + " " + className}
                        className={((window.innerWidth < 1550) ? "rmdp-mobile " : "")}
                        name="Checkoutdate"
                        required={true}
                        disabled={false}
                         calendarPosition="bottom"
                      //   selected={Date.now()}
                       //  format='YYYY-MM-dd'
                        // minDate={minDate}
                      //  calendar={gregorian} 
                        locale={"en"} 
                     value={Cust_tasvie_date} 
                  
                   onChange={changeCust_tasvie_date}
                        // range={range}
                        // rangeHover={range}
                    />
            <label  for="checkoutdate" style={{marginLeft:'20px'}}>Sum  Amount</label>
                <input
                        type="text"
                        id="Prese_Id"
                        disabled={true}
                        value={Cust_mab}
                        onChange={(e) =>
                            setCust_mab(e.target.value)
                        }
                        // //placeholder="Enter First Name"
                        required
                        style={{width:'160px',marginLeft:'5px'}}
                    />
                    <div>
                    <label  for="checkoutdate" style={{marginLeft:'0px'}}>Management approval</label>
            <input style={{ marginLeft: "50px", width: '30px' }}
                type="checkbox"
                name="Cust_ok"
                id="Cust_ok"
                disabled={false}
                value={Cust_ok}
               checked={Cust_ok}
                onChange={(e) => setCust_ok(e.target.checked)}
                defaultValue={0}
                //placeholder=""
                required
              />
              </div>
         </div>
         </form>
          </fieldset>
          </div>
          </div> 
          <div className="CheckIn" style={{display:'inline-block', width:'300px',height:'600px', marginLeft:'-50px',marginTop:'0px'}}>  
 
              <Cost_List Listview={listview} Room_Number={params.id} data={datalist}  />

 </div>  
</div> 
        </>
  
        
    );

}
export default Cost;